const textSizeMap = new Map();

const FJDomUtil = {
    /**
     * 计算问文本长度
     *
     * @param {string} text
     * @param {object} fontInfo
     * @param {string} fontInfo.fontFamily
     * @param {number} fontInfo.fontSize
     * @param {string} fontInfo.fontStyle
     * @param {string} fontInfo.fontWeight
     * @param {object} overrideStyle
     */
    calcTextSize: function (text = '', fontInfo = {}, overrideStyle = {}) {
        const {
            fontFamily = 'Montserrat',
            fontSize = 14,
            fontStyle = 'normal',
            fontWeight = 'normal',
            lineHeight = 'inherit',
            spacing = 'inherit',
        } = fontInfo;
        const textFontStyle = { fontFamily, fontSize, fontStyle, fontWeight, lineHeight, spacing };
        const key = `${text}-${JSON.stringify(textFontStyle)}-${JSON.stringify(overrideStyle)}`;
        if (textSizeMap.has(key)) {
            return textSizeMap.get(key);
        }

        let div = document.getElementById('flexclip-calc-text');
        if (!div) {
            div = document.createElement('div');
            div.id = 'flexclip-calc-text';

            const baseStyles = {
                transform: 'scale3d(1, 1, 1)',
                contenteditable: 'false',
                display: 'inline-block',
                zIndex: '-1',
                position: 'fixed',
                whiteSpace: 'nowrap',
                opacity: '0',
                ...textFontStyle,
                ...overrideStyle,
            };

            Object.assign(div.style, baseStyles);
            document.body.appendChild(div);
        }

        Object.assign(div.style, textFontStyle, overrideStyle);
        div.innerHTML = text.replace(/\s/g, '&nbsp;');
        const { width, height } = div.getBoundingClientRect();
        const size = { width, height };
        textSizeMap.set(key, size);
        return { ...size };
    },
};

export default FJDomUtil;
